import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jhi-autocertificazioni-emesse',
  templateUrl: './autocertificazioni-emesse.component.html',
  styleUrls: ['./autocertificazioni-emesse.component.scss']
})
export class AutocertificazioniEmesseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
